import { ChevronRightIcon } from '@heroicons/react/24/outline'
import { equipmentMedia } from 'functions/equipmentUtils'

import ContentFrame from 'components/Frame/ContentFrame'

export default function EquipmentProfilePreviewCard({
    equipmentProfile = null,
    OnEquipmentProfileSelected = (equipmentProfile) => { console.log('Pass in function to EquipmentProfilePreviewCard') },
    styleForClickability = true
}) {

    const RenderEquipmentSummary = (equipmentProfileJSON) => {
        // console.log(equipmentProfileJSON)

        const plateCount = equipmentProfileJSON.plateAvailability.reduce((sum, plate) => sum + plate.quantity, 0)
        const dumbbellCount = equipmentProfileJSON.dumbbellAvailability.reduce((sum, db) => sum + db.quantity, 0)
        const kettlebellCount = equipmentProfileJSON.kettlebellAvailability.reduce((sum, kb) => sum + kb.quantity, 0)

        return (
            <div className="space-y-2">
                <div className="text-gray-600 space-y-1 ">

                    <div className='flex items-center gap-2'>
                        <img 
                            src={equipmentMedia['barbell']?.imageURL}
                            alt={equipmentMedia['barbell']?.name}
                            className="w-5 h-5 object-contain"
                        />
                        <p className='text-sm'>Plates: {plateCount} total</p>
                    </div>

                    <div className='flex items-center gap-2'>
                        <img 
                            src={equipmentMedia['dumbbell']?.imageURL}
                            alt={equipmentMedia['dumbbell']?.name}
                            className="w-5 h-5 object-contain"
                        />
                        <p className='text-sm'>Dumbbells: {dumbbellCount} total</p>
                    </div>

                    <div className='flex items-center gap-2'>
                        <img 
                            src={equipmentMedia['kettlebell']?.imageURL}
                            alt={equipmentMedia['kettlebell']?.name}
                            className="w-5 h-5 object-contain"
                        />
                        <p className='text-sm'>Kettlebells: {kettlebellCount} total</p>
                    </div>

                </div>
            </div>
        )
    }

    return (
        <ContentFrame>
            <div 
                className={`rounded-xl p-4 relative w-full ${styleForClickability ? 'cursor-pointer' : ''}`}
                onClick={() => OnEquipmentProfileSelected(equipmentProfile)}
            >
                {styleForClickability && <ChevronRightIcon className="h-5 w-5 text-gray-400 absolute top-4 right-4" />}

                <div className="flex items-center justify-between mb-1">
                    <h3 className="text-lg text-gray-900">{equipmentProfile.name}</h3>
                </div>

                {equipmentProfile.description.length > 0 && (
                    <p className="text-left text-sm mb-2 text-gray-600 truncate">{equipmentProfile.description}</p>
                )}

                {equipmentProfile.description.length === 0 && (
                    <p className="text-left text-sm mb-2 text-gray-600 truncate">No description</p>
                )}
                
                {RenderEquipmentSummary(JSON.parse(equipmentProfile.equipmentProfileJSON))}
            </div>
        </ContentFrame>
    )
}